<template>
  <div id="app" class="wrapper" style="height:100vh;overflow: auto;">
    <router-view />
   
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      title: ""
    };
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  font-family: PingFangSC-Medium, PingFang SC;
}
html ,body{
    height: 100vh;
}
.tabImg {
  width: 100%;
  height: 400px;
  min-width: 1200px;
}
.tabImg p {
  text-align: center;
  font-size: 24px;
  color: #fff;
  height: 33px;
  line-height: 33px;
  position: relative;
}
.tabImg p::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -10px;
  width: 20px;
  height: 4px;
  transform: translate(-50%, 0);
  background-color: #0078c0;
}
.page {
  display: flex;
  justify-content: center;
  align-items: center;
}
.page.el-pagination.is-background .el-pager li.active {
  background-color: #0078c0;
}
.is-active .el-collapse-item__wrap {
  padding-top: 20px;
  box-sizing: border-box;
}
.el-collapse-item__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 86px !important;
  line-height: 86px !important;
  padding-left: 70px;
  padding-right: 56px;
  box-sizing: border-box;
  border-bottom: 1px solid #e3e3e3;
}
.social .el-collapse-item__arrow {
  display: none !important;
}
.el-collapse-item__header.is-active {
  border-bottom-color: #e3e3e3;
}

ul,
li {
  list-style: none;
  box-sizing: border-box;
}
textarea {
  resize: none;
}
input:focus,
textarea:focus {
  outline: none;
  border-color: #1a4532 !important;
}
a {
  color: #333;
  text-decoration: none;
}
a:hover,
a:link {
  color: #333;
}
i {
  display: block;
  font-style: normal;
}
div,
a {
  box-sizing: border-box;
}

#app {
  font-family: PingFangSC-Medium, PingFang SC Microsoft YaHei;
}
.mdBox {
  width: 1200px;
  margin: 0 auto;
}
.flex-row {
  display: flex;
  flex-wrap: wrap;
}
.flex-row.row-than {
  flex: 1;
}
.flex-row.row-top {
  align-items: flex-start;
}
.flex-row.row-middle {
  align-items: center;
}
.flex-row.row-bottom {
  align-items: flex-end;
}
.flex-row.row-left {
  justify-content: flex-start;
}
.flex-row.row-center {
  justify-content: center;
}
.flex-row.row-right {
  justify-content: flex-end;
}
.flex-row.row-between {
  justify-content: space-between;
}
.flex-row.row-around {
  justify-content: space-around;
}
.flex-row.row-column {
  flex-direction: column;
}
.flex-row.row-column-between {
  flex-direction: column;
  justify-content: space-between;
}
.flex-row.row-column-around {
  flex-direction: column;
  justify-content: space-around;
}
.flex-row.row-center-wrapper {
  align-items: center;
  justify-content: center;
}
.flex-row.row-between-wrapper {
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/App.vue